import React from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

const SuggestionsContainer = styled.div`
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  z-index: 10;
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 10px;
`;

const SuggestionItem = styled.div`
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f0f0f0;
  }
`;

const DrinkInfo = styled.div`
  flex: 1;
`;

const DrinkName = styled.div`
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

const DrinkDescription = styled.div`
  font-size: 0.9em;
  color: #666;
  line-height: 1.3;
`;

const PriceTag = styled.div`
  font-weight: 500;
  color: #333;
  margin-left: 15px;
  white-space: nowrap;
`;

const DrinkSearchAutocomplete = ({ onDrinkSelect }) => {
  const drinks = [
    {
      name: 'Old Fashioned',
      description: 'Bourbon, bitters, sugar, and a twist of orange',
      price: 14.00
    },
    {
      name: 'Margarita',
      description: 'Tequila, lime juice, triple sec',
      price: 12.00
    },
    {
      name: 'Moscow Mule',
      description: 'Vodka, ginger beer, lime juice',
      price: 13.00
    },
    {
      name: 'Mojito',
      description: 'White rum, lime juice, mint, and soda',
      price: 12.00
    },
    {
      name: 'Negroni',
      description: 'Gin, Campari, and sweet vermouth',
      price: 13.00
    },
    {
      name: 'Martini',
      description: 'Gin or vodka and dry vermouth',
      price: 14.00
    },
    {
      name: 'Daiquiri',
      description: 'White rum, lime juice, and simple syrup',
      price: 12.00
    },
    {
      name: 'Manhattan',
      description: 'Whiskey, sweet vermouth, and bitters',
      price: 14.00
    }
  ];

  const handleDrinkClick = (drink) => {
    onDrinkSelect({
      type: 'userSelection',
      drink: drink,
      message: `I'll have a ${drink.name}`,
      nextMessage: `Great choice! Your ${drink.name} will be $${drink.price.toFixed(2)}. Would you like to proceed with payment?`
    });
  };

  return (
    <SearchContainer>
      <SuggestionsContainer>
        {drinks.map((drink) => (
          <SuggestionItem 
            key={drink.name}
            onClick={() => handleDrinkClick(drink)}
          >
            <DrinkInfo>
              <DrinkName>{drink.name}</DrinkName>
              <DrinkDescription>{drink.description}</DrinkDescription>
            </DrinkInfo>
            <PriceTag>${drink.price.toFixed(2)}</PriceTag>
          </SuggestionItem>
        ))}
      </SuggestionsContainer>
    </SearchContainer>
  );
};

export default DrinkSearchAutocomplete;